export default __webpack_public_path__ + "static/media/Padron50thAnn.fbeeb637.png";